import { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import moment from "moment";
import { useFormik } from "formik";
import loaderImage from "../image/Rolling-1s-200px.svg";
import * as Yup from "yup";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import { toastAlert } from "../config/toastAlert";
import { get_job_details_one } from "../config/apiCall";
import { toast } from "react-toastify";
import httpService from "../config/httpCall";
import { jobuserFormSubmit } from "../config/apiCall";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
};

const JobOpenings = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [formApply, setFormApply] = useState(false);
  const [NewFormMobileValue, setNewFormMobileValue] = useState();
  const [pageloader, setpageloader] = useState(false);
  const [jobPositionValue, setjobPositionValue, jobPositionValueref] =
    useState();
  const [jobDepartmentValue, setjobDepartmentValue, jobDepartmentValueref] =
    useState();
  const [selectedTitle, setSelectedTitle] = useState("");
  const [jobpdf, setjobpdf] = useState();
  const [jobpdfName, setjobpdfName] = useState();
  const [jobpositionErr, setjobpositionErr, jobpositionref] = useState();
  const [details, setdetails] = useState({});
  const [loader, setloader] = useState(false);
  // console.log(Details, "Details====");

  const handleOpen = async (jobslug) => {
    try {
      setpageloader(true);

      const obj = { id: jobslug };
      const resp = await get_job_details_one(obj);

      if (resp.status === true) {
        const jobData = resp.Message.get_job_data;

        setdetails(jobData);
        setjobPositionValue(jobData.jobPosition);
        setjobDepartmentValue(jobData.jobDepartment);
        setOpen(true);
      } else {
        console.error("Failed to fetch job details:", resp);
      }
    } catch (error) {
      console.error("Error in handleOpen:", error);
    } finally {
      setpageloader(false);
    }
  };

  const handleClose = () => {
    if (selectedTitle) {
      formik.resetForm();
      setOpen(false);
      setFormApply(false);
    } else {
      setOpen(false);
      setFormApply(false);
    }
  };

  const handleFormApply = (jobDepartment) => {
    setFormApply(true);
    setSelectedTitle(jobDepartment);
  };

  const jobfileUpload = async (val) => {
    const fileExtension = val.name.split(".").at(-1);
    const fileSize = val.size;

    if (
      fileExtension !== "doc" &&
      fileExtension !== "docx" &&
      fileExtension !== "pdf"
    ) {
      toastAlert("error", "File type must be .doc, .docx, or .pdf");
      return false;
    }

    if (fileSize > 1000000) {
      toastAlert("error", "Please upload a file smaller than 1 MB");
      return false;
    }

    const formData = new FormData();
    formData.append("file", val);
    setloader(true);

    const apiUrl = "https://api.pinata.cloud/pinning/pinFileToIPFS";
    const apiKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI3YThmNTc3NS1iYjkzLTQ0YjAtOTI3MS00YzNmOTM0Yjc0YmYiLCJlbWFpbCI6ImpleWFyYWptQGJlbGVhZnRlY2hub2xvZ2llcy5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJGUkExIn0seyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJOWUMxIn1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiYzc1ZDIyZDViY2IwZWE3ZjdkM2YiLCJzY29wZWRLZXlTZWNyZXQiOiJmNTZlNWRlZjY5MzU3YTI0ZDgyZTI2MzQ1M2FhNTEzNzg2YmU5ZWM0YzVhZDc2YzFhNmNhYTEzY2FjZTI5YmZjIiwiZXhwIjoxNzgzNjgzNDIxfQ.h-gLF-UW_P6lrckBVUGxQqn6_zqUwsvgAKrkdRwu2O0";

    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${apiKey}`,
        },
      });

      const ipfsHash = response.data.IpfsHash;
      const url = `https://gateway.pinata.cloud/ipfs/${ipfsHash}`;

      setjobpdf(url);
      setjobpdfName(val.name);
      setloader(false);

      return url;
    } catch (error) {
      console.error("Pinata upload error:", error);
      toastAlert("error", "Something went wrong while uploading to Pinata");
      setloader(false);
      return false;
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      degree: "",
      mobile: "",
      experience: "",
      resume: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .matches(/^([^0-9$%]*)$/, "Only alphabets allowed in Name")
        .required("Name is required"),
      degree: Yup.string().required("Degree is required"),
      mobile: Yup.string().required("Mobile number is required"),
      experience: Yup.string().required("Experience is required"),
      resume: Yup.string().required("Resume is required"),
    }),
    onSubmit: async (values) => {
      console.log("Form values:", values);

      const jobObj = {
        name: values.name,
        degree: values.degree,
        mobile: values.mobile,
        experience: values.experience,
        resume: values.resume,
      };

      const data = {
        apiUrl: httpService.jobuserFormSubmit,
        payload: jobObj,
      };

      const messageSent = await jobuserFormSubmit(data);
      // const messageSent = await jobuserFormSubmit();

      if (messageSent.success === true) {
        toast.success(messageSent.message || "Form submitted successfully!");
        setTimeout(() => {
          window.$("#intern_apply").modal("hide");
          window.location.href = "https://beleaftechnologies.com/sucesspage";
        }, 1500);
        formik.resetForm();
        setjobpdf("");
        setjobpdfName("");
      } else {
        toast.error(messageSent.message);
      }
    },
  });

  return (
    <>
      <button
        onClick={() => handleOpen(data.jobslug)}
        className="open-role-card"
      >
        <span className="card-department">{data.jobDepartment}</span>
        <h3 className="card-role">{data.jobDescription}</h3>
        {/* <h6 className="card-duration">
          {"Time"} : {data.jobtiming}
        </h6> */}
        <h6 className="card-duration">
          Experience : {data && data.experience ? data.experience : "-"}
        </h6>
        {/* <p>{moment(data.updatedAt).fromNow()}</p> */}
        {/* <p className="card-type">{data.experience}</p> */}
        <button className="mt-4 career-btn re-hero-btn nw_cr_btn_fz">
          <div className="nw_cr_ap_txt">Apply Now </div>
          <span className="mx-2 right-arr">
            <i className="fa-solid fa-arrow-right"></i>
          </span>
        </button>
        {/* <div className="card-time">
          <span>
            <i className="bi bi-briefcase"></i>
            {data.time}
          </span>
          <span>
            <i className="fa-solid fa-clock-rotate-left"></i>
            {data.months}
          </span>
        </div> */}
      </button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={style}
          className={`modals career_modals ${
            formApply && "career_form_modals"
          }`}
        >
          {!formApply ? (
            <div>
              <div className="career_modals-header">
                <div className="career_modal-arrow">
                  <i
                    onClick={() => handleClose()}
                    className="fa-solid fa-xmark"
                  ></i>
                </div>
                <div className="modals-header_wrap">
                  <div>
                    <h5 className="career_modals-header-title">
                      {/* Digital Marketing Executive */}
                      {details.jobDepartment}
                    </h5>
                    <p className="career_modals-header-content">
                      {details.jobDescription}
                    </p>
                  </div>
                  {/* <div className="ml-auto sm-btn-none">
                    <button
                      onClick={handleFormApply}
                      className="career_modals-header-btn"
                    >
                      Apply Now
                    </button>
                  </div> */}
                </div>
              </div>
              <div className="career_modals-main">
                {/* <div>
                  <h6 className="career_modals-main-title">Join Our Team!</h6>
                  <p className="career_modals-main-content">
                    Beleaf Technologies, India's leading enterprise blockchain
                    technology solution and service provider, is looking for
                    passionate and driven individuals to join our growing team.
                  </p>
                </div>
                <div className="mt-4">
                  <h6 className="career_modals-main-title">About Us:</h6>
                  <p className="career_modals-main-content">
                    At Beleaf Technologies, we specialize in delivering
                    personalized blockchain solutions, blockchain development,
                    crypto exchange platforms, and token development services.
                    Our innovative approach helps businesses harness the power
                    of blockchain technology to drive growth and efficiency.
                  </p>
                </div>
                <div className="mt-4">
                  <h6 className="career_modals-main-title">
                    Key Responsibilities:
                  </h6>
                  <ul className="career-lists">
                    <li className="career_modals-main-content">
                      Execute and optimize SEO strategies to drive organic
                      growth
                    </li>
                    <li className="career_modals-main-content">
                      Manage and enhance our presence on social media platforms
                    </li>
                    <li className="career_modals-main-content">
                      Implement social media marketing campaigns
                    </li>
                    <li className="career_modals-main-content">
                      Conduct SEM (Search Engine Marketing) activities for brand
                      visibility
                    </li>
                    <li className="career_modals-main-content">
                      Lead initiatives and contribute to marketing strategies
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <h6 className="career_modals-main-title">
                    Must-Have Skills:
                  </h6>
                  <ul className="career-lists">
                    <li className="career_modals-main-content">
                      Proficiency in Search Engine Optimization (SEO)
                    </li>
                    <li className="career_modals-main-content">
                      Expertise in Social Media Optimization (SMO)
                    </li>
                    <li className="career_modals-main-content">
                      Hands-on experience with Social Media Marketing (SMM)
                    </li>
                    <li className="career_modals-main-content">
                      Experience in Search Engine Marketing (SEM)
                    </li>
                    <li className="career_modals-main-content">
                      Strong leadership and communication skills
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <h6 className="career_modals-main-title">Why Join Us?</h6>
                  <ul className="career-lists">
                    <li className="career_modals-main-content">
                      Be part of a fast-growing blockchain development company
                    </li>
                    <li className="career_modals-main-content">
                      Work in a dynamic and collaborative environment
                    </li>
                    <li className="career_modals-main-content">
                      Contribute to cutting-edge projects in the blockchain
                      space
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <div>
                    <span className="career_modals-details">Location : </span>
                    <span className="career_modals-details">
                      Madurai, Tamil Nadu (On-site only)
                    </span>
                  </div>
                  <div className="mt-3">
                    <span className="career_modals-details">Experience : </span>
                    <span className="career_modals-details">
                      6 months to 1+ years
                    </span>
                  </div>
                </div> */}

                <p
                  className="career_ds_cnt"
                  dangerouslySetInnerHTML={{ __html: details.content }}
                ></p>

                <div className="ml-auto mt-3 sm-btn-none">
                  <button
                    onClick={() => handleFormApply(details.jobPosition)}
                    className="career_modals-header-btn"
                  >
                    Apply Now
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="career_modals-header">
                <div className="career_modal-arrow">
                  <i
                    onClick={() => handleClose()}
                    className="fa-solid fa-xmark"
                  ></i>
                </div>
                <div className="text-center">
                  <p className="career-form-content">Apply for</p>
                  <h4 className="career-form-title">
                    {selectedTitle ? selectedTitle : ""}
                  </h4>
                </div>
              </div>
              <div className="career_modals-main whole_fom_pad">
                <form onSubmit={formik.handleSubmit}>
                  <label htmlFor="name" className="career-form-label">
                    Name<span className="text-danger">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    className="career-form-input"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      // Prevent leading space
                      if (value === "" || value[0] !== " ") {
                        formik.setFieldValue(name, value);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className="text-danger">{formik.errors.name}</div>
                  )}

                  <div className="row my-4">
                    <div className="col-lg-6">
                      <label htmlFor="degree" className="career-form-label">
                        Degree<span className="text-danger">*</span>
                      </label>
                      <br />
                      <input
                        type="text"
                        id="degree"
                        name="degree"
                        placeholder="Enter your degree"
                        className="career-form-input"
                        onChange={(e) => {
                          const { name, value } = e.target;
                          // Prevent leading space
                          if (value === "" || value[0] !== " ") {
                            formik.setFieldValue(name, value);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.degree}
                      />
                      {formik.touched.degree && formik.errors.degree && (
                        <div className="text-danger">
                          {formik.errors.degree}
                        </div>
                      )}
                    </div>

                    <div className="col-lg-6 md-mt-5">
                      <label className="career-form-label">
                        Mobile Number<span className="text-danger">*</span>
                      </label>
                      <br />
                      <PhoneInput
                        country={"in"}
                        value={formik.values.mobile}
                        onChange={(value) =>
                          formik.setFieldValue("mobile", value)
                        }
                        inputProps={{
                          name: "phonenumber",
                          required: true,
                        }}
                        autoComplete="off"
                        containerClass="career-form-phone"
                      />
                      {formik.touched.mobile && formik.errors.mobile && (
                        <div className="text-danger">
                          {formik.errors.mobile}
                        </div>
                      )}
                    </div>
                  </div>

                  <label htmlFor="experience" className="career-form-label">
                    Experience<span className="text-danger">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    id="experience"
                    name="experience"
                    placeholder="Year of experience"
                    className="career-form-input"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      // Prevent leading space
                      if (value === "" || value[0] !== " ") {
                        formik.setFieldValue(name, value);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.experience}
                  />
                  {formik.touched.experience && formik.errors.experience && (
                    <div className="text-danger">
                      {formik.errors.experience}
                    </div>
                  )}

                  <br />
                  <div className="career_file-wrapper mt-4">
                    <label htmlFor="experience" className="career-form-label">
                      Resume<span className="text-danger">*</span>
                    </label>

                    <div
                      className="resume_upload_head"
                      onClick={() =>
                        document.getElementById("resumeUploadInput").click()
                      }
                    >
                      <input
                        id="resumeUploadInput"
                        type="file"
                        name="resume"
                        accept=".pdf,.doc,.docx"
                        className="career_file-upload"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const uploadedUrl = await jobfileUpload(file);
                            if (uploadedUrl) {
                              formik.setFieldValue("resume", uploadedUrl);
                            }
                          }
                        }}
                      />

                      <div
                        className="flex_upload"
                        style={{ textAlign: "center" }}
                      >
                        {jobpdf ? (
                          <img
                            src="https://res.cloudinary.com/dpnvbcrn2/image/upload/v1734704278/download_1_brdsui.jpg"
                            className="w-100"
                            alt="uploaded"
                          />
                        ) : loader === false ? (
                          <i className="fas fa-file-upload"></i>
                        ) : (
                          <img
                            src={loaderImage}
                            className="w-100"
                            alt="loading"
                          />
                        )}
                        {jobpdf ? <p>{jobpdfName}</p> : <p>Upload File</p>}
                      </div>
                    </div>

                    {formik.touched.resume && formik.errors.resume && (
                      <div className="text-danger">{formik.errors.resume}</div>
                    )}
                  </div>

                  <div className="p-0 pb-0 justify-content-center d-flex mt-3">
                    <button
                      type="submit"
                      className="mt-3 career-file-btn re-hero-btn"
                    >
                      <div className="nw_cr_pop_txt">Submit </div>
                      <span className="mx-2 right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default JobOpenings;
